import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('FormRowLayout');

export const formRowLayoutClassNames = {
  root: factory.root(),
  startColumn: factory.element('start-column'),
  endColumn: factory.element('end-column'),
  topDivider: factory.attribute('top-divider'),
  bottomDivider: factory.attribute('bottom-divider'),
  loading: factory.attribute('loading'),
};
